
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customize-bundle-for-shp2",
      function () {
        return require("private-next-pages/customize-bundle-for-shp2/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customize-bundle-for-shp2"])
      });
    }
  